import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../store/store';
import baseServices from "../../services/base.services";
import  moment from 'moment'

//import { fetchCount } from './counterAPI';

export interface DataLog {
  code: string;
  username: string;
  logMessage: string;
  name: string;
  lastname: string;
  date: string;
  tagStatus: string;
  status: number;
}


export interface DataComment {
  idComment: string;
  comment: string;
  rut: string;
  name: string;
  lastname: string;
  status: string;
  date: string;
  tagStatus: string;
  dateUpdate: string;
  log: Array<DataLog>;
}


export interface DashboardState {
  selectedRange: string;
  selectedTabs: any;
  vistaSearch: any
  status: 'idle' | 'loading' | 'failed';
  data: Array<any>;
  data2: Array<any>;
  comment: String;
}

const initialState: DashboardState = {
  selectedRange: 'D',
  selectedTabs: {id: 1, name: 'Recibido'},
  status: 'idle',
  vistaSearch: false,
  data: [],
  data2: [],
  comment: ''
};

//////////////////////////
export const getAllResultsDashboard = createAsyncThunk(
  'range/getAllResultsDashboard',
  async (_props: any) => {
    var data: any = {};
    
    const response1 = await baseServices.getAllResults({ 
      period: _props.period
    });

    // The value we return becomes the `fulfilled` action payload
    return {data: response1.data}
  }
);

export const DashboardSlice = createSlice({
  name: 'range',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    
        
    changeTabs: (state: DashboardState, action:any) => {
      state.selectedTabs = action.payload;
    },
    changeRangeDate: (state: DashboardState, action:any) => {
      state.selectedRange = action.payload;
    },

  
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder : any) => {
    builder

      .addCase(getAllResultsDashboard.pending, (state: DashboardState) => {
        state.status = 'loading';
      
      })
      .addCase(getAllResultsDashboard.fulfilled, (state: DashboardState, action: any) => {

        {/*@ts-ignore*/}
        state.status = 'idle';
      
        state.data = [
          
            { name: 'Recibido', y: action.payload.data.filter((x: any)=> x.Status == 1).length},
            { name: 'Analizando', y: action.payload.data.filter((x: any)=> x.Status == 2).length },
            { name: 'Definicion', y: action.payload.data.filter((x: any)=> x.Status == 3 || x.Status == 4).length },
            { name: 'Realizado', y: action.payload.data.filter((x: any)=> x.Status == 5).length },
           
        ]
        
        state.data2 = [
          
          { name: 'Aprobado', y: action.payload.data.filter((x: any)=> x.Status == 3).length},
          { name: 'Rechazado', y: action.payload.data.filter((x: any)=> x.Status == 4).length},
         
      ]
      
      

        {/*@ts-ignore*/}
//        state.data = state.data.find(x=> x.idComment == action.payload.idComment).map(x=> x.status = action.payload.status);
      })
  },
});

export const { changeRangeDate, changeTabs } = DashboardSlice.actions;
export const selectedDateRange = (state: RootState) => state.dashboardPageReducer.selectedRange;
export const selectedTabs = (state: RootState) => state.dashboardPageReducer.selectedTabs;


export default DashboardSlice.reducer;
